var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"value":_vm.value,"label":_vm.label,"items":_vm.items,"loading":_vm.isLoading,"disabled":_vm.disabled,"rules":_vm.rules,"color":_vm.color,"hide-details":_vm.hideDetails,"outlined":_vm.outlined,"clearable":_vm.clearable},on:{"change":_vm.valueChanged,"input":_vm.isValidated}})
}
var staticRenderFns = []

export { render, staticRenderFns }